var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAssistantSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 55,
    viewBox: "0 0 25 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.8046V27.3418V11.3563C1.41404 9.52874 2.49997 5.87356 6.99998 5.87356C7.41402 4.24904 6.01895 1 9 1H10.2156C11.3804 1.19042 13.6374 2.09512 13.9139 4.21644C14.489 4.11017 15.1208 4.04598 15.8051 4.04598C19.5314 4.04598 24.4998 5.26437 24.4998 12.5747V25.977V29.023V42.4253C24.4998 49.7356 19.5314 50.954 15.8051 50.954C15.1208 50.954 14.489 50.8898 13.9139 50.7836C13.6374 52.9049 11.3804 53.8096 10.2156 54H9C6.106 54 7.33627 50.9379 7.03178 49.2728H6.99998C2.50003 49.2728 1.41404 45.6176 1 43.79V27.8046Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.8046V11.3563C1.41404 9.52874 2.49997 5.87356 6.99998 5.87356M6.99998 5.87356H9.59456C10.8367 6.48276 13.3209 9.89425 13.3209 18.6667V27.8046M6.99998 5.87356C7.41402 4.24904 6.01895 1 9 1L10.2156 1C11.4577 1.20307 13.9419 2.21839 13.9419 4.65517M1 27.3418V43.79C1.41404 45.6176 2.50003 49.2728 6.99998 49.2728H9.59456C10.8367 48.6636 13.3209 45.2521 13.3209 36.4797V27.3418M10.2156 5.87356C10.8367 5.26437 12.824 4.04598 15.8051 4.04598C19.5314 4.04598 24.4998 5.26437 24.4998 12.5747V29.023M10.2156 49.1264C10.8367 49.7356 12.824 50.954 15.8051 50.954C19.5314 50.954 24.4998 49.7356 24.4998 42.4253V25.977M6.99998 49.1264C7.41402 50.751 6.01895 54 9 54H10.2156C11.4577 53.7969 13.9419 52.7816 13.9419 50.3448",
    stroke: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssistantSeat);
export default __webpack_public_path__ + "static/media/ic-assistant-seat.abd6bb5667acc9463f7a79ca2db99b90.svg";
export { ForwardRef as ReactComponent };